import * as React from 'react';
import { userData } from '../../../util/userData';
import { HttpRequest } from '../../../util/http';
import {Spinner} from "reactstrap";

interface User {
  id: number
  username: string
  label: string
}



interface UserSelectProps {
  value?: number
  selectedUserID?: number
  onChange: (newValue: number) => void
  label?: string
  users?: User[]
  readOnly?: boolean
  required?: boolean
  isSaving?: boolean
}

interface UserSelectState {
  users: User[]
  filteredUsers: User[]
  label: string
  selectedUserID: number
  isDropdownOpen: boolean
  filterQuery: string
}
export class UserSearchSelect extends React.Component<UserSelectProps, UserSelectState> {
  private readonly node: React.RefObject<HTMLDivElement>;
  state: UserSelectState = {
    selectedUserID: undefined,
    users: [],
    filteredUsers: [],
    label: '',
    isDropdownOpen: false,
    filterQuery: ''
  }

  constructor(props) {
    super(props);
    this.state.selectedUserID = (this.props.selectedUserID ? this.props.selectedUserID : undefined);
    this.state.users = (this.props.users ? this.props.users : []);
    this.state.filteredUsers = (this.props.users ? this.props.users : []);
    this.state.label = (this.props.label ? this.props.label : 'User');

    this.filterUserList = this.filterUserList.bind(this);
    this.handleInputQuery = this.handleInputQuery.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleEscKey = this.handleEscKey.bind(this);
    this.node = React.createRef();
  }

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClick, false);
    document.addEventListener('keydown', this.handleEscKey, false);
  }
  componentDidMount() {
    this.getUsers();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props != prevProps) {
      this.setState({ selectedUserID: this.props.selectedUserID });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
    document.removeEventListener('keydown', this.handleEscKey, false);
  }

  handleClick(e) {
    if (e.target.id == 'dropdwonListOfUsers' || e.target.id == 'filterQuery' || e.target.className == 'dropdown-item' || e.target.id == 'dropdownMenuButton') {
      return
    }
    this.handleClickOutside();
  }

  handleClickOutside() {
    this.setState({ isDropdownOpen: false });
  }

  handleEscKey(e) {
    if (e.keyCode === 27 && this.state.isDropdownOpen) {
      this.setState({ isDropdownOpen: false });
    }
  }
  handleInputQuery(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    let partialState = {};
    partialState[name] = value;

    this.setState(partialState, () => this.filterUserList(value));
  }

  getUsers() {
    const project = userData.getCurrentProject();
    userData.getUserId().then((userId) => {
      const data = {current_project: project, user_id: userId};
      const method = 'POST';
      HttpRequest.fetch('scripts/my_alerts/get_user_list', {data, method})
        .then((res: any) => {
          let users = [];
          res.users.forEach((user) => {
            users.push(user);
          });
          this.setState({users: users, filteredUsers: users});
        })
    })
  }

  displaySelectedUser(userID: number) {
    const users = this.state.users;
    if (users[users.findIndex((item) => item.id == userID)]) {
      return users[users.findIndex((item) => item.id == userID)].username;
    } else {
      return 'Select a Default User'
    }
  }

  toggleDropdownList() {

  }

  filterUserList(query: string) {
    let userList = this.state.users;
    let filteredList = userList.filter(function (user) {
      return user.username.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    });
    this.setState({ filteredUsers: filteredList });
  }

  render() {
    const { users, filteredUsers, selectedUserID, isDropdownOpen } = this.state;
    const { onChange, isSaving } = this.props;
    return (
      <>
        <div>
          <div className="dropdown">
            <button className="btn btn-outline-dark dropdown-toggle d-flex justify-content-between" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onClick={() => this.setState({ isDropdownOpen: !isDropdownOpen })}>
              <span>{this.displaySelectedUser(selectedUserID)} </span>
              <span className={(isSaving ? '' : 'd-none')}><Spinner color="secondary" style={{ width: '1.5rem', height: '1.5rem' }} /></span>
              {!isSaving &&
              <>
                  <span className={(selectedUserID ? 'd-none' : '')}><i className="fas fa-caret-down"/></span>
                  <span className={(!selectedUserID ? 'd-none' : '')}><i className="fas fa-pencil-alt text-primary"/></span>
              </>
              }
            </button>
            <div className={(isDropdownOpen ? 'dropdown-menu show' : 'dropdown-menu')} aria-labelledby="dropdownMenuButton" ref={this.node} id='dropdwonListOfUsers'>
              <input type="search" name="filterQuery" id="filterQuery" onChange={this.handleInputQuery} value={this.state.filterQuery} />
              {filteredUsers.map((user, idx) => {
                return (
                  <a className="dropdown-item" key={idx} onClick={() => {
                    this.setState({
                      isDropdownOpen: false,
                      filterQuery: '',
                      filteredUsers: users
                    });
                    onChange(user.id);
                  }}>{user.username}</a>
                );
              })}
            </div>
          </div>
        </div>
      </>
    );
  }
}